// extracted by mini-css-extract-plugin
export default {"textoExplicativo":"PerfilEdit_textoExplicativo__DuXPT"};